/**
 * Add a span with class "en" around English text in the content.
 *
 * Dependencies: jQuery
 */

jQuery(document).ready(function() {
  
  /*
   This function uses a regex pattern to match English text and wrap it in a span.
  * It is applied to the content of posts and pages.
  * The regex pattern is designed to match runs of Latin letters, numbers, and common punctuation. */
  //only ru this if the document lang is set to ja-JP
  if (document.documentElement.lang !== 'ja-JP') {
    return;
  }
  // Select all articles in the document
  // and create a TreeWalker to traverse the text nodes
  document.querySelectorAll('article').forEach(article => {
    // 1) Gather all text-nodes containing Latin characters
    const walker = document.createTreeWalker(
      article,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          return /\p{Script=Latin}/u.test(node.nodeValue)
            ? NodeFilter.FILTER_ACCEPT
            : NodeFilter.FILTER_REJECT;
        }
      }
    );
    const textNodes = [];
    let current;
    while (current = walker.nextNode()) {
      textNodes.push(current);
    }

    // 2) Process each one, wrapping every Latin-run
    const wrapRE = /(\p{Script=Latin}[\p{Script=Latin}\d’ʼ‘‚“”.,;:!?–—\-]*)+/gu;
    textNodes.forEach(node => {
      const replaced = node.nodeValue.replace(
        wrapRE,
        '<span class="en" lang="en">$&</span>'
      );
      if (replaced !== node.nodeValue) {
        const frag = document.createRange()
                            .createContextualFragment(replaced);
        node.parentNode.replaceChild(frag, node);
      }
    });
  });
  

});
